import { MARKER_COLORS } from "./consts.js";

class MarkerComponent {
    static render(type, count) {
        const color = MARKER_COLORS[type] || "";

        return count >= 10
            ? this.#renderLargeMarker("#242424", count, type)
            : this.#renderSmallMarker("#242424", count, type);
    }

    static #renderLargeMarker(color, count, type) {
        return this.#createSvgElement(`
      <svg data-type="${type}" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect class="background" width="28" height="28" rx="14" fill="white" fill-opacity="0.8" shape-rendering="crispEdges"/>
        <rect x="1" y="1" width="26" height="26" rx="13" stroke="#242424" stroke-opacity="0.8" stroke-width="2" shape-rendering="crispEdges"/>
        <text x="3" y="19.5" font-family="Jost" font-weight="500" font-size="14" fill="#242424">10+</text>
        <filter id="filter0_d_811_16019" x="0" y="0" width="30" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_811_16019" result="shape"/>
        </filter>
      </svg>
    `);
    }

    static #renderSmallMarker(color, count, type) {
        return this.#createSvgElement(`
      <svg data-type="${type}" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect class="background" width="28" height="28" rx="14" fill="white" fill-opacity="0.8" shape-rendering="crispEdges"/>
        <rect x="1" y="1" width="26" height="26" rx="13" stroke="#242424" stroke-opacity="0.8" stroke-width="2" shape-rendering="crispEdges"/>
        <text x="9.5" y="19.5" font-family="Jost" font-weight="500" font-size="16" fill="#242424">${count}</text>
        <filter id="filter0_d_811_16019" x="0" y="0" width="30" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_811_16019" result="shape"/>
        </filter>
      </svg>
    `);
    }

    static #createSvgElement(svgString) {
        const parser = new DOMParser();
        const document = parser.parseFromString(svgString, "image/svg+xml");
        return document.documentElement;
    }
}

export default MarkerComponent;
